module.exports = __webpack_public_path__ + "static/media/cotiza.049367ce.svg";